
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqe5d7lr6e8rWibWIfh5f80KMIXVdcctyCQVS3WopvB0oMeta } from "/codebuild/output/src1704339645/src/src/pages/faq.vue?macro=true";
import { default as menut4_45Scs0GeG_45kaTHg6bgDlv2umKH0bjsqaoUXMavT7t8Meta } from "/codebuild/output/src1704339645/src/src/pages/menu.vue?macro=true";
import { default as indexC7Yi3HI0Q22ckPqVFCH8aKV5bKfp_sUcenTRgzectRgMeta } from "/codebuild/output/src1704339645/src/src/pages/index.vue?macro=true";
import { default as contact04ptwO2eI3_7jhxxK0Y0ZQqPi_wGfUjWzFgjC65rEKUMeta } from "/codebuild/output/src1704339645/src/src/pages/contact.vue?macro=true";
import { default as tutorialv8yD17NRQISbvLYZhWbcFaKM3q3_453__9JZHUYVFVliIMeta } from "/codebuild/output/src1704339645/src/src/pages/tutorial.vue?macro=true";
import { default as agreementO5N50gK9fgOmvTiTFJ370KFqDx8NF3_4Z0OEINjSo7QMeta } from "/codebuild/output/src1704339645/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass6AqybtKJiuvvqoJf_45IHPksUXPFIZwVVhlbWbzX_45haTgMeta } from "/codebuild/output/src1704339645/src/src/pages/about-pass.vue?macro=true";
import { default as indexDS6thvt5rRfA_45IbJ1TMuWCSM9La2ZF9kWku6MHNPjkQMeta } from "/codebuild/output/src1704339645/src/src/pages/card/index.vue?macro=true";
import { default as _91id_938h94mhSmJXWcb5eb8RFtmqmga6mBm5SCKFUCeH1i564Meta } from "/codebuild/output/src1704339645/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance7eO7j_45xKD65Zq3oUdibGDSafEIKKQojg24RMnLqgvv4Meta } from "/codebuild/output/src1704339645/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_uVDCwJ83SyQ_HfrxXQvyIyEVRBosV7X0ZFEAHppbC8Meta } from "/codebuild/output/src1704339645/src/src/pages/notice/[id].vue?macro=true";
import { default as index__t8ShgutFMJ1dr9N2FknORdccAA0cxh0H7vNifw_451oMeta } from "/codebuild/output/src1704339645/src/src/pages/coupon/index.vue?macro=true";
import { default as indexafAwxMB_45iamtHITHH59_cea60zubeyOp6V_VYkDA_45PEMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/index.vue?macro=true";
import { default as indexjkwsGEZeO7Rp6c_45G9iN2Ya0W9DWa8Nwf7lS_s7WUBaoMeta } from "/codebuild/output/src1704339645/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93e5BTnHJPblm4tcFCRxwJqE51y5h6_v8HUw0qDvFQZhQMeta } from "/codebuild/output/src1704339645/src/src/pages/parking/[id].vue?macro=true";
import { default as indexpTKzivnyEC7rh0J4olDM0qMmrXDQO_RT4Iz9UX_lrk0Meta } from "/codebuild/output/src1704339645/src/src/pages/history/index.vue?macro=true";
import { default as indexNzvqXES5O14wORIjuZPR6PWtu4jNxdTzz7ChWUMFhsQMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/index.vue?macro=true";
import { default as indexsw43dpsq9KJmqfhuj3SJfijXADJSROkwXu2i0iXEDgoMeta } from "/codebuild/output/src1704339645/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexTeB5FeEbOuCHJI81jHYHvCGbgVl81ejuG7Xv4nH80X4Meta } from "/codebuild/output/src1704339645/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviRQA_Yb_45rTyz7k4AcbLwUtAiRck3bUNFfsN6cQNBMF00Meta } from "/codebuild/output/src1704339645/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit7YTd1GGXqf2Vahv33PTfBoLhhjN6L01633XBnlxZ0gUMeta } from "/codebuild/output/src1704339645/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement59CJSFWd21daQCmZJ9c57RCVtfTBTiK9y7JDCr7gDjAMeta } from "/codebuild/output/src1704339645/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexmaUQmk5lG3lkuZwq3sSabJoLdHqI4PH6qJNsoGmJ3MgMeta } from "/codebuild/output/src1704339645/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453de00MOuSQA12kaFL6ibgBMmNJIKikyRew8V_45bn8EmEQUMeta } from "/codebuild/output/src1704339645/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmboivUwvJEBZH3GdzLRt7WmMtlCYZNk7TD63_45g0KETS0Meta } from "/codebuild/output/src1704339645/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexkyuPqfpzYGrij7DvgwyB4qxoKZVwoXefujzjloRMigUMeta } from "/codebuild/output/src1704339645/src/src/pages/card/create/index.vue?macro=true";
import { default as indexVjAp9BTDv7vqoOBN6YJutqgec5w82JdbWdRySFvLdqQMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmhWvNVZ543K3Nl42YhDeW99S5_4RAgsS7yDvqo_45DFu3kMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmHLdupXCBNnPAyND8kRneQGn0F4KDnl_Orkp77gqrF7QMeta } from "/codebuild/output/src1704339645/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeMBIQvf2Adk864BT3lkrafBOFGL66eV1XcNvCPUTrl_sMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/complete.vue?macro=true";
import { default as registergYBZ979l9sQLtnq1I1ctQZq8CClOWPmh39PUeA57aMoMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93OY1TAV70_0mr9uY9RgHD3RCNpUxZxh_45eAkUj3AP9hAcMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmYkJLmoPJbpsa8fcK_45D6sKRshYSh8o2uQLiLY_GZVEGYMeta } from "/codebuild/output/src1704339645/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_45MtHqoEHyiZiM7qmSkuus48mpcnf0a5cZPQitxhptwQMeta } from "/codebuild/output/src1704339645/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexutGxbhOzKE5pOk8qbdZseX35W_BNBh3yYwHa6gTUJUcMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codemwhQhZih1c4CjXV5zn_45LU1YYoTAjdoC5nybwAAbTBrEMeta } from "/codebuild/output/src1704339645/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codebjhgX_45vTwBxUoodZ1jev9POkzK0qVRmNWFGdz0IlDXsMeta } from "/codebuild/output/src1704339645/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeAbfZT_59Uwc5XMyIBY0RBQ6Bqq5BTjPhom_4592Z6apWEMeta } from "/codebuild/output/src1704339645/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerffwxCwKCsx_bRtxMk3xUKQXIWg8lHEihXLjnroVqoxcMeta } from "/codebuild/output/src1704339645/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeJyFZsotbMgdzzS2STNviaTzR_n6RN_PX5Si0kVVJgscMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexvpcLWVGsSJQ0O72dyO1ZFYZRSLVK4USJYNiZbP0Hw_450Meta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmZPaWnCCyUkCtoXuboFdpcZivK_kEBCvUj0Bur8DQgEEMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeN8FXF1J2d8Aqf3ar1HQcd3AEx9xvzPHBAf2hx0Fh2VwMeta } from "/codebuild/output/src1704339645/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexCY1uRwywFoJEfNQZuV0_45lsTV9vYM1e4KfGDrQ6LgZy0Meta } from "/codebuild/output/src1704339645/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_932YXDAcgrii1MjB8MahYPyFJuz8piKXR0V9kyKn50GEkMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete06RaF_lFcMnKa_45FbAlo8oAx3Zmlo6o4ZpquwJKDCge0Meta } from "/codebuild/output/src1704339645/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasKNlWONVePS_HeTDjxHZtUgi10q13GtGCjJBVIibWlysMeta } from "/codebuild/output/src1704339645/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplewIc1Sq741_p_45R7TtyaqwO6VKgPe9DNTBBfnOHISkjzUMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email6lac10WeaWCgrX6mCu_80lBh5vnZEIvgOC3zIavtDC0Meta } from "/codebuild/output/src1704339645/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmv0RqN6D1lzJNLWPd1Mo1tcWp5lK2OVa9_454wzP2AkABgMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentsWXZpcA8YmxNh8ZXC08Rw4BbKWuK1kWGV8sB_6itHfgMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmF0A5PgkZr2fNX8Eq4nfMUbBvrIHfk8rpMZSBMOmFwroMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatexMc263ovPXsHfj_gU5I2_45OObL_45b4pkjZTo5T2TUt94EMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completenVBMt5N0XwrjilLo0YIEYTjEKXayZYSp0_ces1mhNUQMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeUq5yR893zj_45whYQKAPwinFS7wKfrIhR79QLbfPE_45mToMeta } from "/codebuild/output/src1704339645/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordZjw_4510HCPN7a2rGvdmncvjS_0W8qoOgPRSEbwHTZxQQMeta } from "/codebuild/output/src1704339645/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasOiqWRkqbaHR1FpgGjNBd74IZvLc_452x8k6cnagF5yNv4Meta } from "/codebuild/output/src1704339645/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register0r0j5bpmUVj58gLgW_453c1NFenVFkjSa0h4vwiWix4iYMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeTXhmWY1_45dyPeahIcKO23gCYDddhSkKg7sDakK1pXPXAMeta } from "/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexM_45gw15tZwJxBR6Vdrp9PYpQgLLfuodEDsHIaY7I0gAMMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexqx_3sTPBfu0zGRYziCsATRtYyqTx9ogSo0zIck_fBvwMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexNYF6pqiGW0_AvXFwkNLZWnZZUs6Rz9sJuuybMLgy_ioMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexwbZSYmgMootbRphCfNwDzmD3HENkAPFemZ7tMTlshVkMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update2wx8QaV_uuxXFInFEGo7oO3WfdgTH1_45012b6VrrGrRkMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete3LjvAquDXzCSnQ4Mq8VwieyQiHkq1PuoBhWInO3zWiQMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmqjBpcoi1eSnaJsqT3JMkqMjepC64_45_45FX5rLX06C4UUgMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexwcp7_45_45sxjetGJl8Ux1tstV8To9gh1hEnoPtyfmWp4oYMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeE982a0UlbN_yUwD_aD7l5KF50Oedt0vRG7mk9HeNZe8Meta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateZRd_5uON_45445UjHczR5Yo2QTz_GbqQTyoHxLjx_lVlgMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexHHC65IbF4ITfh1FbIDWQngYhmMqrxKAcLrSt9IwKslQMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexTnOTohh2tL_DV7B_jtr1x5amN4Nop0v0jvuv00mZ_44Meta } from "/codebuild/output/src1704339645/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeksvmkmaS1JxexNP7gT1d_ya7bpF8_45jdx1qMYNxtWK7cMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index7bqyZ5Dc4Abipz8_45cYU4xIfSb2HLndyFrpUT4gZoumMMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeMXkdQHdtfdt_45_45CxPgGlVFUL6gc25WTpG1YpMQS1PnasMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexynNTfBbzYKJSIVBnOAC7oe5hw7PxMJH4WQykWdftL3YMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexGQ7fZzpxSFU_ArQ4U11Por76Bu5Ruf_yx4FLzi1xWjgMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexkT9wsQo7_454MYKAmcKUM4vvoGgmaa2_45069JEqtyOK8igMeta } from "/codebuild/output/src1704339645/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateFvCma2aYV4kZ4YfeiJ3jVdgPCQPrhywu7UCq61YZPrcMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmPs6yNQt1JZOzhCft98hBUvqzJAAukKGY0lmmmHsodTAMeta } from "/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menut4_45Scs0GeG_45kaTHg6bgDlv2umKH0bjsqaoUXMavT7t8Meta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexC7Yi3HI0Q22ckPqVFCH8aKV5bKfp_sUcenTRgzectRgMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index__t8ShgutFMJ1dr9N2FknORdccAA0cxh0H7vNifw_451oMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexpTKzivnyEC7rh0J4olDM0qMmrXDQO_RT4Iz9UX_lrk0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexsw43dpsq9KJmqfhuj3SJfijXADJSROkwXu2i0iXEDgoMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexTeB5FeEbOuCHJI81jHYHvCGbgVl81ejuG7Xv4nH80X4Meta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexkyuPqfpzYGrij7DvgwyB4qxoKZVwoXefujzjloRMigUMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmhWvNVZ543K3Nl42YhDeW99S5_4RAgsS7yDvqo_45DFu3kMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmHLdupXCBNnPAyND8kRneQGn0F4KDnl_Orkp77gqrF7QMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeMBIQvf2Adk864BT3lkrafBOFGL66eV1XcNvCPUTrl_sMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registergYBZ979l9sQLtnq1I1ctQZq8CClOWPmh39PUeA57aMoMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmYkJLmoPJbpsa8fcK_45D6sKRshYSh8o2uQLiLY_GZVEGYMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codemwhQhZih1c4CjXV5zn_45LU1YYoTAjdoC5nybwAAbTBrEMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codebjhgX_45vTwBxUoodZ1jev9POkzK0qVRmNWFGdz0IlDXsMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeAbfZT_59Uwc5XMyIBY0RBQ6Bqq5BTjPhom_4592Z6apWEMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerffwxCwKCsx_bRtxMk3xUKQXIWg8lHEihXLjnroVqoxcMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmZPaWnCCyUkCtoXuboFdpcZivK_kEBCvUj0Bur8DQgEEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeN8FXF1J2d8Aqf3ar1HQcd3AEx9xvzPHBAf2hx0Fh2VwMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexCY1uRwywFoJEfNQZuV0_45lsTV9vYM1e4KfGDrQ6LgZy0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete06RaF_lFcMnKa_45FbAlo8oAx3Zmlo6o4ZpquwJKDCge0Meta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplewIc1Sq741_p_45R7TtyaqwO6VKgPe9DNTBBfnOHISkjzUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email6lac10WeaWCgrX6mCu_80lBh5vnZEIvgOC3zIavtDC0Meta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmv0RqN6D1lzJNLWPd1Mo1tcWp5lK2OVa9_454wzP2AkABgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentsWXZpcA8YmxNh8ZXC08Rw4BbKWuK1kWGV8sB_6itHfgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmF0A5PgkZr2fNX8Eq4nfMUbBvrIHfk8rpMZSBMOmFwroMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completenVBMt5N0XwrjilLo0YIEYTjEKXayZYSp0_ces1mhNUQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeUq5yR893zj_45whYQKAPwinFS7wKfrIhR79QLbfPE_45mToMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordZjw_4510HCPN7a2rGvdmncvjS_0W8qoOgPRSEbwHTZxQQMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register0r0j5bpmUVj58gLgW_453c1NFenVFkjSa0h4vwiWix4iYMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeTXhmWY1_45dyPeahIcKO23gCYDddhSkKg7sDakK1pXPXAMeta || {},
    component: () => import("/codebuild/output/src1704339645/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1704339645/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]